import React, { useEffect, useState } from 'react';
import InputField from '../../../../component/form/FormInput';
import ImageUpload from '../../../../component/uplaodImage';
import Checkbox from '../../../../component/checkbox';
import AppendInput from '../../../../component/form/AppendInput';
import InputSelect from '../../../../component/inputSelect/InputSelect';
import Modal from '../../../../component/modal/Modal';
import AddProductGroup from '../productGroup/AddProductGroup';
import { useDispatch, useSelector } from 'react-redux';
import { useBlocker, useNavigate, useParams } from 'react-router-dom';
import ProductCatogery from '../productCatogery/ProductCatogery';
import { ObjectCreate } from '../../../../utils/utility';
import { product_group_list } from '../../../../store/action/group';
import Addshelf from '../shelf/Shelf';
import { product_catogery_list } from '../../../../store/action/catogery';
import { shelf_list } from '../../../../store/action/shelf';
import { master_data } from '../../../../store/action/master';
import { HSN_list } from '../../../../store/action/utility';
import Button from '../../../../component/ui/Button';
import AddProductTable from './AddProductTable';
import tooltipIcon from '../../../../assets/image/tooltip_vendor name.png';
import {
	change_status,
	product_Update,
	product_code_get,
	product_create,
} from '../../../../store/action/product';
import { toast } from 'react-toastify';
import BulkImport from '../BulkImport';
import ModalRight from '../../../../component/modalRight';
import { formatErrors, hasPermission } from '../../../../utils/controller';
import CreateGroupCodeModel from '../productGroup/createGroupCodeModel';
import { getDate } from '../../../../utils/dateUtils';
import {
	createDraftProduct,
	deleteDraftProduct,
	getDraftProductList,
	getProductDetails,
	publishDraftProduct,
	updateDraftProduct,
} from '../../../../services/products';
import {
	getMeasuringUnitGeneral,
	getPackagingGeneral,
} from '../../../../services/settings/inventory';
import { getTaxRates } from '../../../../services/settings/organization';

const CreateProduct = () => {
	const suburl = localStorage.getItem('suburl');
	const param = useParams();
	const productID = param?.id;
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [errorCells, setErrorCells] = useState([]);
	const [isNextLocation, setIsNextLocation] = useState(null);
	const [isLocationBlocker, setIsLocationBlocker] = useState(true);
	const [isProductAutoSave, setIsProductAutoSave] = useState(false);
	const [isOpenGroupCodeModel, setIsOpenGroupCodeModel] = useState(false);
	const [autoFocus, setAutoFocus] = useState({
		catogrey: false,
		product: false,
		shelf: false,
		tax1: false,
	});
	const [projectTitle, setProjectTitle] = useState('Create Product');
	const [error, setError] = useState({});
	const [isOpenCatogery, setIsOpenCatogery] = useState(false);
	const [open, setOpen] = useState(false);
	const [isSheifId, setIsShelfId] = useState(false);
	const masterData = useSelector((state) => state?.master?.masterData?.data);
	const HSNData = useSelector((state) => state?.utility?.data?.data);
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const [clone, setClone] = useState(false);
	const [groupOption, setGroupOptions] = useState([]);
	const [catogeryOption, setCatogeryOption] = useState([]);
	const [shelfOption, setShelfOption] = useState([]);
	const [packagingOption, setPackagingOption] = useState([]);
	const [unitOption, setUnitOption] = useState([]);
	const [HSNoption, setHSNoption] = useState([]);
	const [disabled, setDisabled] = useState(productID ? true : false);
	const [openProductCode, setOpenProductCode] = useState(false);
	const [openAddBatchDetails, setOpenAddBatchDetails] = useState(false);
	const [openHSNCode, setOpenHSNCode] = useState(false);
	const [openPacking, setOpenPacking] = useState(false);
	const [openUnit, setOpenUnit] = useState(false);
	const [openShelfID, setOpenShelfID] = useState(false);
	const [buklImport, setIsbuklImport] = useState(false);
	const [productCode, setproductCode] = useState('');
	const [persistGroupName, setPersistGroupName] = useState('');
	const [group, setGroup] = useState('');
	const [persistCatogey, setPersistCatogery] = useState('');
	const [category, setCategory] = useState('');
	const [persistShlef, setPersistShelf] = useState('');
	const [shelf, setShelf] = useState('');
	const [groupCode, setGroupCode] = useState('');
	const [isErrortable, setIsTableError] = useState(false);
	const [pageLoader, setPageLoader] = useState({
		isLoading: false,
		isSave: false,
		isDraft: false,
	});
	const [tableData, setTableData] = useState([]);
	const [productTabelError, setProductTableError] = useState(false);
	const [productData, setProductData] = useState(null);
	const [taxesList, setTaxesList] = useState([]);

	const product_code = () => {
		let param = `product_group_id=${group}`;
		product_code_get(param).then((res) => {
			if (res?.success) {
				setproductCode(res?.data);
			}
		});
	};
	useEffect(() => {
		if (group && !param) {
			product_code();
		}
	}, [group]);

	const getProductById = async () => {
		if (productID && !isNaN(productID)) {
			const product_details = await getProductDetails(productID);
			setProductData(product_details);
			setProjectTitle('Product Details');
		} else if (productID && productID.includes('id')) {
			const params = new URLSearchParams(productID);
			const map = Object.fromEntries(params.entries());
			const { product_details } = await getDraftProductList(map.id);
			setProductData(product_details);
		}
	};

	useEffect(() => {
		getProductById();
	}, [productID]);
	const navigateRouter = (path) => {
		navigate(path);
	};
	const HandleGroupChange = async (value, code) => {
		setGroup(value);
		setGroupCode(code);
		if (value) {
			delete error?.product_group_id;
		}
		if (code) {
			getProductCode(value);
		}
	};

	async function getProductCode(value) {
		let param = `product_group_id=${value}`;
		var res = await product_code_get(param);
		if (res?.success) {
			setproductCode(res?.data);
			delete error?.product_code;
		}
	}

	const handleCatogery = (value) => {
		setCategory(value);
		if (value) {
			delete error?.category_id;
		}
	};

	const [formData, setFormData] = useState({
		name: '',
		hsn_id: '',
		packaging_id: '',
		contains: '',
		unit_id: '',
		sell_loose: true,
		tax1: '',
		tax2: '',
		purchase_discount: '0.00',
		min_stock: '0',
		max_stock: '0',
		generic_name: '',
		product_image: null,
	});

	useEffect(() => {
		if (groupCode) {
			getProductCode(group);
		}
	}, [groupCode]);

	useEffect(() => {
		if (productID) {
			let BatchData = [];

			productData?.product_batch?.map((ele) => {
				BatchData?.push({
					batch_no: ele?.batch_no?.toString(),
					product_batch_id: ele?.product_batch_id?.toString(),
					quantity: ele?.quantity?.toString(),
					free_quantity: ele?.free_quantity?.toString(),
					mfg_date: getDate(ele?.mfg_date, false, false, true) ?? '',
					expiry_date: getDate(ele?.expiry_date, false, false, true) ?? '',
					mrp: ele?.mrp?.toString(),
					trade_rate: ele?.trade_rate?.toString(),
					purchase_rate: ele?.purchase_rate?.toString(),
					sale_rate: ele?.sale_rate?.toString(),
				});
			});
			setFormData({
				name: productData?.product_name || '',
				product_code: productData?.product_code || '',
				hsn_id: productData?.hsn_id || '',
				packaging_id: productData?.packaging_id || '',
				contains: productData?.contains || '',
				unit_id: productData?.unit_id || '',
				sell_loose: productData?.sell_loose || false,
				tax1: productData?.tax1,
				tax2: productData?.tax2,
				purchase_discount: productData?.purchase_discount || '',
				min_stock: productData?.min_stock || '0',
				max_stock: productData?.max_stock || '0',
				generic_name: productData?.generic_name || '',
				product_image: productData?.image || null,
			});
			setCategory(productData?.category_id || '');
			setGroup(productData?.product_group_id || '');
			setShelf(productData?.shelf_id || '');
			setTableData(BatchData);
			setproductCode(productData?.product_code);
			const newGroup = {
				key: productData?.product_group?.product_group_id,
				value: productData?.product_group?.name,
			};
			setGroupOptions((prevOptions) => {
				const exists = prevOptions.some((item) => item.key === newGroup.key);
				if (!exists) {
					return [...prevOptions, newGroup];
				}
				return prevOptions;
			});
		}
	}, [productData]);

	useEffect(() => {
		groupList();
		catogeryList();
		shelfList();
		dispatch(master_data());
		dispatch(HSN_list());
	}, [disabled]);

	useEffect(() => {
		groupList();
	}, [persistGroupName]);

	useEffect(() => {
		catogeryList();
	}, [persistCatogey]);

	useEffect(() => {
		shelfList();
	}, [persistShlef]);

	// useEffect(() => {
	// 	const unit_result = ObjectCreate({
	// 		data: masterData?.units,
	// 		key: 'unit_id',
	// 		value: 'name',
	// 	});
	// 	const packaing_result = ObjectCreate({
	// 		data: masterData?.packagingList,
	// 		key: 'packaging_id',
	// 		value: 'name',
	// 	});
	// 	setUnitOption(unit_result);
	// 	setPackagingOption(packaing_result);
	// }, [masterData]);
	const getInventoryPackaging = async () => {
		try {
			const { packages } = await getPackagingGeneral({
				filterBy: 'is_active',
				filterValue: true,
				pageSize: 10000,
				page: 1,
			});
			const data = ObjectCreate({
				data: packages,
				key: 'id',
				value: 'name',
			});
			setPackagingOption(data);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		}
	};
	const getInventoryMeasuringUnit = async () => {
		try {
			const { units } = await getMeasuringUnitGeneral({
				filterBy: 'is_active',
				filterValue: true,
				pageSize: 10000,
				page: 1,
			});
			const data = ObjectCreate({
				data: units,
				key: 'id',
				value: 'name',
			});
			setUnitOption(data);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		}
	};

	useEffect(() => {
		getInventoryPackaging();
	}, []);
	useEffect(() => {
		getInventoryMeasuringUnit();
	}, []);

	useEffect(() => {
		const result = ObjectCreate({
			data: HSNData,
			key: 'hsn_id',
			value: 'hsn_code',
		});
		setHSNoption(result);
	}, [HSNData]);

	const handleImageUpload = (imageFile) => {
		const updatedData = { ...formData, product_image: imageFile };
		setFormData(updatedData);
	};

	const handleCheckboxChange = (checked) => {
		const updatedData = { ...formData, sell_loose: checked };
		setFormData(updatedData);
	};

	const handleInputChange = (key, value) => {
		const updatedData = { ...formData, [key]: value };
		setFormData(updatedData);

		if (value) {
			delete error?.[key];
		}
	};

	const groupList = async () => {
		let param = `page=${1}&pageSize=1000&filterBy=status&filterValue=1&isDropdown=true`;
		var res = await product_group_list(param);
		if (res?.success) {
			var productData = res?.data?.productGroups;
			const productGroups = productData?.map((product) => {
				return {
					key: product?.product_group_id,
					value: product?.name,
				};
			});

			setGroupOptions((prev) => [...prev, ...productGroups]);
			setPersistGroupName('');
		}
	};

	const shelfList = async () => {
		let param = `page=${1}&pageSize=1000`;
		var res = await shelf_list(param);
		if (res?.success) {
			var shelves = res?.data?.shelves;
			const shelvesData = shelves?.map((shelve) => {
				return {
					key: shelve?.shelf_id,
					value: shelve?.name,
				};
			});

			setShelfOption(shelvesData);
			setPersistShelf('');
		}
	};
	const catogeryList = async () => {
		let param = `page=${1}&pageSize=1000`;
		var res = await product_catogery_list(param);
		if (res?.success) {
			var categoryData = res?.data?.productCategories;
			const categories = categoryData?.map((category) => {
				return {
					key: category?.category_id,
					value: category?.name,
				};
			});
			setCatogeryOption(categories);
			setPersistCatogery('');
		}
	};

	const markAsInactive = () => {
		let productIds = Number(productID);
		let formbody = {
			product_ids: [productIds],
			status: 0,
		};
		change_status(formbody).then((res) => {
			if (res?.success) {
				toast.success(res?.message);
				getProductById();
			} else {
				toast.error(res?.message);
			}
		});
	};
	const markAsactive = () => {
		let productIds = Number(productID);
		let formbody = {
			product_ids: [productIds],
			status: 1,
		};

		change_status(formbody).then((res) => {
			if (res?.success) {
				toast.success(res?.message);
				getProductById();
			} else {
				toast.error(res?.message);
			}
		});
	};
	const cloneProduct = () => {
		setTableData([]);
		setFormData({
			name: '',
			packaging_id: formData?.packaging_id,
			contains: formData?.contains,
			unit_id: formData?.unit_id,
			sell_loose: formData?.sell_loose,
			tax1: formData?.tax1,
			tax2: formData?.tax2,
			purchase_discount: formData?.purchase_discount,
			min_stock: '0',
			max_stock: '0',
			hsn_id: formData.hsn_id,
			generic_name: '',
			product_image: null,
		});
		setClone(true);
		product_code();
		setDisabled(false);
	};
	const productAdujustment = () => {
		navigate(
			`/user/${suburl}/inventory-adjustment-crete?prodid=${productID}&prod=${productData?.product_name}`,
		);
	};

	const getTaxesList = async () => {
		try {
			const { tax_rates } = await getTaxRates({
				pageSize: 10000,
				page: 1,
				filterBy: '',
				filterValue: '',
			});
			const taxes = tax_rates.map((data) => {
				return {
					key: data.rate_in_percentage,
					value: `${data.tax_name} ${data.rate_in_percentage}%`,
				};
			});
			setTaxesList(taxes);
		} catch (error) {
			toast.error(error.message || 'Somenthing went wrong!');
		}
	};

	function checkValidation() {
		let newError = { ...error };
		let newErrorCell = [...errorCells];

		if (tableData.length > 0) {
			let productIndex = tableData.length - 1;
			const lastRow = tableData[productIndex];

			const isLastRowEmpty = [
				lastRow.batch_no,
				lastRow.quantity,
				lastRow.purchase_rate,
				lastRow.mfg_date,
				lastRow.expiry_date,
				lastRow.mrp,
			].every((val) => val === '' || val === null);

			if (isLastRowEmpty) {
				tableData.pop();
				newErrorCell = newErrorCell.filter((err) => err.index !== productIndex);
				Object.keys(newError).forEach((key) => {
					if (newError[key] !== undefined) {
						delete newError[key];
					}
				});
			} else {
				if (!lastRow.batch_no) {
					newErrorCell.push({ index: productIndex, field: 'batch_no' });
					newError.batch_no = '';
				} else {
					delete newError.batch_no;
				}

				if (!lastRow.quantity) {
					newErrorCell.push({ index: productIndex, field: 'quantity' });
					newError.quantity = '';
				} else {
					delete newError.quantity;
				}

				if (
					Number(lastRow.free_quantity || 0) > 0 &&
					Number(lastRow?.quantity) < Number(lastRow.free_quantity)
				) {
					newErrorCell.push({ index: productIndex, field: 'free_quantity' });
					newError.free_quantity = '';
				} else {
					delete newError.free_quantity;
				}

				if (!lastRow.purchase_rate || Number(lastRow.purchase_rate) === 0) {
					newErrorCell.push({ index: productIndex, field: 'purchase_rate' });
					newError.purchase_rate = '';
				} else {
					delete newError.purchase_rate;
				}

				if (!lastRow.mfg_date) {
					newErrorCell.push({ index: productIndex, field: 'mfg_date' });
					newError.mfg_date = '';
				} else {
					delete newError.mfg_date;
				}

				if (!lastRow.expiry_date) {
					newErrorCell.push({ index: productIndex, field: 'expiry_date' });
					newError.expiry_date = '';
				} else {
					delete newError.expiry_date;
				}

				if (!lastRow.mrp || Number(lastRow.mrp) === 0) {
					newErrorCell.push({ index: productIndex, field: 'mrp' });
					newError.mrp = '';
				} else {
					delete newError.mrp;
				}

				if (
					Number(lastRow.sale_rate) > 0 &&
					(Number(lastRow.sale_rate) < Number(lastRow.purchase_rate) ||
						Number(lastRow.sale_rate) > Number(lastRow.mrp))
				) {
					newErrorCell.push({ index: productIndex, field: 'sale_rate' });
					newError.sale_rate = '';
				} else {
					delete newError.sale_rate;
				}
			}
		}

		if (Object.keys(newError).length > 0 || newErrorCell.length > 0) {
			setErrorCells(newErrorCell);
			setError(newError);
			return true;
		} else {
			return false;
		}
	}

	const publishDraftForm = async () => {
		const isErrorShow = checkValidation();
		if (isErrorShow) {
			toast.error('Unable to create or update product');
		} else {
			try {
				setPageLoader((prev) => ({
					...prev,
					isLoading: true,
					isSave: true,
				}));
				const draftFormData = SaveFormData();
				const params = new URLSearchParams(productID);
				const map = Object.fromEntries(params.entries());
				const res = await publishDraftProduct(map.id, draftFormData);
				if (res.success) {
					toast.success(res?.message);
					getProductById();
					setDisabled(true);
					setPageLoader((prev) => ({
						...prev,
						isLoading: false,
						isSave: false,
					}));
					navigate(`/user/${suburl}/product`);
				} else {
					let errorObj = formatErrors(res?.data?.message);
					setError(errorObj);
					setPageLoader((prev) => ({
						...prev,
						isLoading: false,
						isSave: false,
					}));
					toast.error(res?.response?.data?.message || res?.data?.message);
					if (Array.isArray(res?.response?.data?.message)) {
						setProductTableError(res?.response?.data?.message);
					}
				}
			} catch (error) {
				setPageLoader((prev) => ({
					...prev,
					isLoading: false,
					isDraft: false,
				}));
				toast.error(error.response?.data?.message || 'something went wrong');
				let errorObj = formatErrors(error?.data?.message);
				setError(errorObj);
				setPageLoader((prev) => ({
					...prev,
					isLoading: false,
					isSave: false,
				}));
				toast.error(error?.errorponse?.data?.message || error?.data?.message);
				if (Array.isArray(error?.errorponse?.data?.message)) {
					setProductTableError(error?.response?.data?.message);
				}
			}
		}
	};

	const handleDeleteDraft = async () => {
		try {
			const params = new URLSearchParams(productID);
			const map = Object.fromEntries(params.entries());
			const res = await deleteDraftProduct(map.id);
			if (res.success) {
				toast.success(res.message);
				navigate(`/user/${suburl}/product`);
			} else {
				toast.error(res.message);
			}
		} catch (error) {}
	};

	const submitDraftForm = async () => {
		try {
			setPageLoader((prev) => ({
				...prev,
				isLoading: true,
				isDraft: true,
			}));
			if (productID) {
				const draftFormData = SaveFormData();
				const params = new URLSearchParams(productID);
				const map = Object.fromEntries(params.entries());
				const res = await updateDraftProduct(map.id, draftFormData);
				toast.success(res?.message);
				getProductById();
				setDisabled(true);
				setPageLoader((prev) => ({
					...prev,
					isLoading: false,
					isDraft: false,
				}));
				navigate(`/user/${suburl}/product`);
			} else {
				const draftFormData = SaveFormData();
				const res = await createDraftProduct(draftFormData);
				toast.success(res?.message);
				setIsLocationBlocker(false);
				setIsProductAutoSave(false);
				setPageLoader((prev) => ({
					...prev,
					isLoading: false,
					isDraft: false,
				}));
				setTimeout(() => {
					navigate(`/user/${suburl}/product`);
				}, 300);
			}
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		}
	};

	const SaveFormData = () => {
		const draftForm = new FormData();
		for (const key in formData) {
			draftForm.append(key, formData[key]);
		}
		draftForm.append('product_code', productCode?.toString());
		draftForm.append('product_group_id', group?.toString());
		draftForm.append('category_id', category?.toString());
		draftForm.append('shelf_id', shelf?.toString());
		let BatchData = [];
		if (tableData?.length > 0 && tableData?.[0]?.batch_no !== '') {
			tableData?.map((ele) => {
				if (productID && clone === false) {
					BatchData?.push({
						product_batch_id: ele?.product_batch_id?.toString(),
						quantity: ele?.quantity.toString(),
						free_quantity: ele?.free_quantity?.toString(),
						mfg_date: ele?.mfg_date,
						expiry_date: ele?.expiry_date,
						mrp: ele?.mrp.toString(),
						trade_rate: Number(ele?.trade_rate || 0)?.toString(),
						purchase_rate: ele?.purchase_rate?.toString(),
						sale_rate: Number(ele?.sale_rate || 0)?.toString(),
						batch_no: ele?.batch_no,
					});
				} else {
					BatchData?.push({
						quantity: ele?.quantity?.toString(),
						free_quantity: ele?.free_quantity?.toString(),
						mfg_date: ele?.mfg_date,
						expiry_date: ele?.expiry_date,
						mrp: ele?.mrp?.toString(),
						trade_rate: Number(ele?.trade_rate || 0)?.toString(),
						purchase_rate: ele?.purchase_rate?.toString(),
						sale_rate: Number(ele?.sale_rate || 0)?.toString(),
						batch_no: ele?.batch_no,
					});
				}
			});
		}
		draftForm.append('product_batch', JSON.stringify(BatchData));
		return draftForm;
	};

	const SubmitForm = () => {
		const isErrorShow = checkValidation();
		if (isErrorShow) {
			toast.error('Unable to create or update product');
		} else {
			setPageLoader(true);
			const dataToSubmit = new FormData();
			for (const key in formData) {
				dataToSubmit.append(key, formData[key]);
			}
			if (!productID || clone) {
				dataToSubmit.append('product_code', productCode?.toString());
			}
			dataToSubmit.append('product_group_id', group?.toString());
			dataToSubmit.append('category_id', category?.toString());
			dataToSubmit.append('shelf_id', shelf?.toString());
			let BatchData = [];
			if (tableData?.length > 0 && tableData?.[0]?.batch_no !== '') {
				tableData?.map((ele) => {
					if (productID && clone === false) {
						BatchData?.push({
							product_batch_id: ele?.product_batch_id?.toString(),
							quantity: ele?.quantity.toString(),
							free_quantity: ele?.free_quantity?.toString(),
							mfg_date: ele?.mfg_date,
							expiry_date: ele?.expiry_date,
							mrp: ele?.mrp.toString(),
							trade_rate: Number(ele?.trade_rate || 0)?.toString(),
							purchase_rate: ele?.purchase_rate?.toString(),
							sale_rate: Number(ele?.sale_rate || 0)?.toString(),
							batch_no: ele?.batch_no,
						});
					} else {
						BatchData?.push({
							quantity: ele?.quantity?.toString(),
							free_quantity: ele?.free_quantity?.toString(),
							mfg_date: ele?.mfg_date,
							expiry_date: ele?.expiry_date,
							mrp: ele?.mrp?.toString(),
							trade_rate: Number(ele?.trade_rate || 0)?.toString(),
							purchase_rate: ele?.purchase_rate?.toString(),
							sale_rate: Number(ele?.sale_rate || 0)?.toString(),
							batch_no: ele?.batch_no,
						});
					}
				});
			}
			if (productID && clone === false) {
				setPageLoader(true);

				dataToSubmit.append('product_batch', JSON.stringify(BatchData));
				dispatch(product_Update(productID, dataToSubmit))
					.then((res) => {
						if (res?.success) {
							toast.success(res?.message);
							getProductById();
							setDisabled(true);
							setTimeout(() => {
								setPageLoader((prev) => ({
									...prev,
									isLoading: false,
									isSave: false,
								}));
							}, 100);
						} else {
							let errorObj = formatErrors(res?.data?.message);
							setError(errorObj);
							setPageLoader((prev) => ({
								...prev,
								isLoading: false,
								isSave: false,
							}));
							toast.error(res?.response?.data?.message || res?.data?.message);
							if (Array.isArray(res?.response?.data?.message)) {
								setProductTableError(res?.response?.data?.message);
							}
						}
					})
					.catch((err) => {
						toast.error('Something went wrong!');
					});
			} else {
				setPageLoader((prev) => ({
					...prev,
					isLoading: true,
					isSave: true,
				}));
				dataToSubmit.append('product_batch', JSON.stringify(BatchData));

				dispatch(product_create(dataToSubmit)).then((res) => {
					if (res?.success) {
						toast.success(res?.message);
						getProductById();
						setIsLocationBlocker(false);
						setIsProductAutoSave(false);
						setTimeout(() => {
							navigate(`/user/${suburl}/product`);
						}, 300);
					} else {
						let errorObj = formatErrors(res?.data?.message);
						setError(errorObj);
						toast.error(res?.response?.data?.message);
						if (Array.isArray(res?.response?.data?.message)) {
							setProductTableError(res?.response?.data?.message);
						}
					}
				});
			}
			setPageLoader(false);
		}
	};
	useEffect(() => {
		document.title = `${projectTitle} | Pharmnex`;
	}, [projectTitle]);

	useEffect(() => {
		getTaxesList();
	}, []);

	useBlocker((tx) => {
		if (!productID && isLocationBlocker) {
			setIsNextLocation(tx);
			setIsProductAutoSave(true);
			return true;
		}
		return false;
	});

	return (
		<>
			{pageLoader ? (
				<div
					className="Page_loader"
					style={{ top: '40%', left: '48%' }}
				></div>
			) : (
				<div className="">
					<div className="">
						{productID ? (
							<div className="product-pg-header add-product">
								<p> {clone ? 'Add New Product' : 'Product Details'}</p>
								<div className="add-product-button">
									{disabled === true && (
										<Button
											type="button"
											className="btn-gray mt-0 px-4"
											button="Edit"
											disabled={
												!hasPermission('inventory.products.edit', user?.role?.role_permissions)
											}
											onClick={() => {
												setDisabled(false);
												setProjectTitle('Update Product');
											}}
										/>
									)}
									{clone === false && (
										<Button
											type="button"
											className="btn-gray mt-0 px-4  "
											button="Adjust"
											onClick={productAdujustment}
										/>
									)}
									{clone === false && (
										<Button
											type="button"
											disabled={
												!hasPermission('inventory.products.clone', user?.role?.role_permissions)
											}
											className="btn-gray mt-0 px-4"
											button="Clone"
											onClick={cloneProduct}
										/>
									)}
									{productData?.status === 0
										? clone === false && (
												<Button
													type="button"
													disabled={
														!hasPermission('inventory.products.edit', user?.role?.role_permissions)
													}
													className="btn-gray mt-0 px-4  "
													button="Mark as Active"
													onClick={markAsactive}
												/>
											)
										: clone === false && (
												<Button
													type="button"
													disabled={
														!hasPermission('inventory.products.edit', user?.role?.role_permissions)
													}
													className="btn-gray mt-0 px-4  "
													button="Mark as Inactive"
													onClick={markAsInactive}
												/>
											)}
									{disabled === false && clone === false && (
										<Button
											type="button"
											className="btn-gray mt-0 px-4"
											button="Batch bulk upload "
											onClick={() => setIsbuklImport(true)}
										/>
									)}
									{disabled === false && (
										<Button
											type="button"
											className="btn-primary mt-0 px-4"
											button="Save"
											disabled={
												productID
													? !hasPermission('inventory.products.edit', user?.role.role_permissions)
													: !hasPermission('inventory.products.create', user?.role.role_permissions)
											}
											onClick={() => {
												setIsProductAutoSave(false);
												SubmitForm();
											}}
											loader={pageLoader}
										/>
									)}
									<Button
										type="button"
										className="mt-0 btn-danger add-pro"
										button=""
										close
										onClick={() => navigateRouter(-1)}
									/>
								</div>
							</div>
						) : (
							<div className="product-pg-header add-product">
								<p>Add New Product</p>
								<div className="add-product-button">
									<Button
										type="button"
										className="btn-primary mt-0 px-4"
										disabled={
											!hasPermission('inventory.products.create', user?.role?.role_permissions)
										}
										button="Save"
										onClick={SubmitForm}
									/>
									{/* <Button type="button" className="btn-dark add-pro" button="Cancel" /> */}
									<Button
										type="button"
										className="mt-0 btn-danger add-pro"
										button=""
										close
										onClick={() => navigateRouter(-1)}
									/>
								</div>
							</div>
						)}
					</div>
					{/*  product Form */}
					<div className="max-w-1297  pt-md-3 px-md-3 pb-md-0 pt-xl-3 px-xl-5 pb-xl-0">
						<div className="row">
							<div className="col-5 mt-4">
								<InputSelect
									options={groupOption || []}
									placeholder="Select Group"
									label="Select Group"
									onChange={(value) => {
										HandleGroupChange(value, '');
										getProductCode(value);
									}}
									value={group}
									onAddNew={
										hasPermission('inventory.groups.create', user?.role?.role_permissions)
											? () => setOpen(true)
											: ''
									}
									disabled={disabled}
									required={true}
									error={error?.product_group_id}
									autoFocus={!param?.id || disabled === false ? true : false}
								/>
							</div>
							<div className="col-5 mt-4">
								<InputSelect
									label="Select Category"
									placeholder="Select Category"
									onChange={(value) => handleCatogery(value)}
									value={category}
									options={catogeryOption || []}
									onAddNew={() => setIsOpenCatogery(true)}
									disabled={disabled}
									required={true}
									error={error?.category_id}
									autoFocus={!param?.id || disabled === false ? autoFocus?.catogrey : false}
								/>
							</div>
							<div className="col">
								<ImageUpload
									imageUrl={formData.product_image}
									onImageUpload={handleImageUpload}
									error={error?.image}
									disabled={disabled}
								/>
							</div>
						</div>
						<div className="row">
							<div className="col">
								<InputField
									label="Product Name"
									placeholder="Product Name"
									type="text"
									required={true}
									value={formData.name}
									onChange={(value) => handleInputChange('name', value)}
									disabled={disabled}
									error={error?.name}
									autoFocus={!param?.id || disabled === false ? autoFocus?.product : false}
								/>
							</div>
							<div className="col">
								<InputField
									label="Product Code"
									placeholder="Product Code"
									type="text"
									required={true}
									value={productCode}
									disabled={true}
									rightIcon={{
										src: tooltipIcon,
										alt: 'tooltips',
										onClick: () => setOpenProductCode(true),
									}}
									onClick={() => setOpenProductCode(true)}
									error={error?.product_code}
								/>
							</div>
							<div className="col">
								<InputSelect
									options={HSNoption || []}
									placeholder="Select HSN Code"
									label="HSN code"
									onChange={(value) => handleInputChange('hsn_id', value)}
									value={formData.hsn_id}
									disabled={disabled}
									infoIcon
									required={true}
									error={error?.hsn_id}
									onClick={() => setOpenHSNCode(true)}
								/>
							</div>
						</div>
						<div className="row">
							<div className="col-8">
								<div className="row justify-content-start align-items-start">
									<div className="col-5">
										<InputSelect
											label="Packing"
											placeholder="Packing"
											onChange={(value) => handleInputChange('packaging_id', value)}
											value={formData.packaging_id}
											options={packagingOption || []}
											infoIcon={true}
											required={true}
											disabled={disabled}
											error={error?.packaging_id}
											onClick={() => setOpenPacking(true)}
										/>
									</div>
									<div className="col-2">
										<InputField
											label="Contains"
											placeholder=""
											type="number"
											onChange={(value) => handleInputChange('contains', value)}
											value={formData.contains}
											disabled={disabled}
											error={error?.contains}
											required={true}
										/>
									</div>
									<div className="col-3">
										<InputSelect
											label="Unit"
											placeholder="Select Unit"
											onChange={(value) => handleInputChange('unit_id', value)}
											value={formData.unit_id}
											options={unitOption || []}
											infoIcon={true}
											required={true}
											disabled={disabled}
											error={error?.unit_id}
											onClick={() => setOpenUnit(true)}
										/>
									</div>
									<div
										className="col-2 align-content-center"
										style={{ marginTop: '33px' }}
									>
										<Checkbox
											label="Sell Loose"
											checked={formData.sell_loose}
											onChange={handleCheckboxChange}
											error={error?.sell_loose}
											disabled={disabled}
											required={true}
										/>
									</div>
								</div>
							</div>
							<div className="col-4">
								<InputSelect
									label="Shelf ID"
									placeholder="Select Shelf ID"
									onChange={(value) => setShelf(value)}
									value={shelf}
									options={shelfOption || []}
									onAddNew={() => setIsShelfId(true)}
									infoIcon={true}
									disabled={disabled}
									error={error?.shelf_id}
									onClick={() => setOpenShelfID(true)}
									autoFocus={!param?.id || disabled === false ? autoFocus?.shelf : false}
								/>
							</div>
						</div>
						<div className="row g-3">
							{/* LEFT SECTION */}
							<div className="col-lg-7 col-md-12">
								<div className="row g-3">
									<div className="col-lg col-md-3">
										<InputSelect
											options={taxesList}
											label="Tax1"
											placeholder="Tax1"
											required={false}
											error={error?.tax1}
											value={formData.tax1}
											returnInputValue={false}
											disabled={disabled}
											onChange={(value) => {
												if (value === '') {
													handleInputChange('tax1', value);
												}
											}}
											onSelect={(option) => {
												handleInputChange('tax1', option.key);
											}}
											autoFocus={!param?.id || disabled === false ? autoFocus?.tax1 : false}
										/>
									</div>

									<div className="col-lg col-md-3">
										<InputSelect
											options={taxesList}
											label="Tax2"
											placeholder="Tax2"
											required={false}
											error={error?.tax2}
											value={formData.tax2}
											returnInputValue={false}
											disabled={disabled}
											onChange={(value) => {
												if (value === '') {
													handleInputChange('tax2', value);
												}
											}}
											onSelect={(option) => {
												handleInputChange('tax2', option.key);
											}}
											autoFocus={!param?.id || disabled === false ? autoFocus?.tax1 : false}
										/>
									</div>

									<div className="col-lg col-md-3">
										<InputField
											label="Discount"
											placeholder=""
											type="text"
											onChange={(value) => handleInputChange('purchase_discount', value)}
											value={formData.purchase_discount}
											disabled={disabled}
											error={error?.purchase_discount}
										/>
									</div>

									<div className="col-lg col-md-3">
										<InputField
											label="Min Stock"
											placeholder=""
											type="text"
											onChange={(value) => handleInputChange('min_stock', value)}
											value={formData.min_stock}
											disabled={disabled}
											error={error?.min_stock}
										/>
									</div>

									<div className="col-lg col-md-3">
										<InputField
											label="Max Stock"
											placeholder=""
											type="text"
											onChange={(value) => handleInputChange('max_stock', value)}
											value={formData.max_stock}
											disabled={disabled}
											error={error?.max_stock}
										/>
									</div>
									{/* RIGHT SECTION */}
									<div className="col-md-4 d-block d-lg-none">
										<InputField
											label="Generic Name"
											placeholder=""
											type="text"
											onChange={(value) => handleInputChange('generic_name', value)}
											value={formData.generic_name}
											disabled={disabled}
											error={error?.generic_name}
										/>
									</div>
								</div>
							</div>

							{/* RIGHT SECTION */}
							<div className="col-lg-5 d-none d-lg-block">
								<InputField
									label="Generic Name"
									placeholder=""
									type="text"
									onChange={(value) => handleInputChange('generic_name', value)}
									value={formData.generic_name}
									disabled={disabled}
									error={error?.generic_name}
								/>
							</div>
						</div>
					</div>

					<div className="d-none d-lg-block">
						<AddProductTable
							className="max-w-1297"
							tableData={tableData}
							setTableData={setTableData}
							disabled={disabled}
							productTabelError={productTabelError}
							setIsTableError={setIsTableError}
							setErrorCells={setErrorCells}
							errorCells={errorCells}
						/>
					</div>
					<div className="d-flex justify-content-end px-3 w-100 d-block d-lg-none">
						<Button
							type="button"
							className="btn-gray mt-0 px-4"
							button="Add Batch Details"
							onClick={() => {
								setOpenAddBatchDetails(!openAddBatchDetails);
							}}
						/>
					</div>

					<div className="add-batch-modal-wrap">
						<Modal
							className="add-batch-modal"
							isOpen={openAddBatchDetails}
							cancelButton={() => setOpenAddBatchDetails(false)}
							onClose={() => setOpenAddBatchDetails(false)}
							title="Add Product Details"
						>
							<AddProductTable
								className="max-w-1297"
								tableData={tableData}
								setTableData={setTableData}
								disabled={disabled}
								productTabelError={productTabelError}
								setIsTableError={setIsTableError}
								setErrorCells={setErrorCells}
								errorCells={errorCells}
							/>
						</Modal>
					</div>

					{openProductCode && (
						<div className="">
							<ModalRight
								show={openProductCode}
								isOpen={openProductCode}
								onClose={() => setOpenProductCode(false)}
								title="Product Code"
								description1="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since."
								description2="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
								description3="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
								linkTitle="Learn More"
								linkPath1="#"
								linkName1="Lorem Ipsum is simply dummy text of the printing"
								linkPath2="#"
								linkName2="Lorem Ipsum is simply dummy text of the printing"
								linkPath3="#"
								linkName3="Lorem Ipsum is simply dummy text of the printing"
								linkPath4="#"
								linkName4="Lorem Ipsum is simply dummy text of the printing"
								linkPath5="#"
								linkName5="Lorem Ipsum is simply dummy text of the printing"
								linkPath6="#"
								linkName6="Lorem Ipsum is simply dummy text of the printing"
							></ModalRight>
						</div>
					)}
					{openHSNCode && (
						<div className="">
							<ModalRight
								show={openHSNCode}
								isOpen={openHSNCode}
								onClose={() => setOpenHSNCode(false)}
								title="HSN Code"
								description1="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since."
								description2="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
								description3="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
								linkTitle="Learn More"
								linkPath1="#"
								linkName1="Lorem Ipsum is simply dummy text of the printing"
								linkPath2="#"
								linkName2="Lorem Ipsum is simply dummy text of the printing"
								linkPath3="#"
								linkName3="Lorem Ipsum is simply dummy text of the printing"
								linkPath4="#"
								linkName4="Lorem Ipsum is simply dummy text of the printing"
								linkPath5="#"
								linkName5="Lorem Ipsum is simply dummy text of the printing"
								linkPath6="#"
								linkName6="Lorem Ipsum is simply dummy text of the printing"
							></ModalRight>
						</div>
					)}
					{openPacking && (
						<div className="">
							<ModalRight
								show={openPacking}
								isOpen={openPacking}
								onClose={() => setOpenPacking(false)}
								title="Product Packing"
								description1="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since."
								description2="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
								description3="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
								linkTitle="Learn More"
								linkPath1="#"
								linkName1="Lorem Ipsum is simply dummy text of the printing"
								linkPath2="#"
								linkName2="Lorem Ipsum is simply dummy text of the printing"
								linkPath3="#"
								linkName3="Lorem Ipsum is simply dummy text of the printing"
								linkPath4="#"
								linkName4="Lorem Ipsum is simply dummy text of the printing"
								linkPath5="#"
								linkName5="Lorem Ipsum is simply dummy text of the printing"
								linkPath6="#"
								linkName6="Lorem Ipsum is simply dummy text of the printing"
							></ModalRight>
						</div>
					)}
					{openUnit && (
						<div className="">
							<ModalRight
								show={openUnit}
								isOpen={openUnit}
								onClose={() => setOpenUnit(false)}
								title="Product Unit"
								description1="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since."
								description2="Lorem Ipsum is simply dummy text of the printing and
typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
								description3="Lorem Ipsum is simply dummy text of the printing and
typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
								linkTitle="Learn More"
								linkPath1="#"
								linkName1="Lorem Ipsum is simply dummy text of the printing"
								linkPath2="#"
								linkName2="Lorem Ipsum is simply dummy text of the printing"
								linkPath3="#"
								linkName3="Lorem Ipsum is simply dummy text of the printing"
								linkPath4="#"
								linkName4="Lorem Ipsum is simply dummy text of the printing"
								linkPath5="#"
								linkName5="Lorem Ipsum is simply dummy text of the printing"
								linkPath6="#"
								linkName6="Lorem Ipsum is simply dummy text of the printing"
							></ModalRight>
						</div>
					)}
					{openShelfID && (
						<div className="">
							<ModalRight
								show={openShelfID}
								isOpen={openShelfID}
								onClose={() => setOpenShelfID(false)}
								title="Shelt ID"
								description1="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since."
								description2="Lorem Ipsum is simply dummy text of the printing and
typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
								description3="Lorem Ipsum is simply dummy text of the printing and
typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
								linkTitle="Learn More"
								linkPath1="#"
								linkName1="Lorem Ipsum is simply dummy text of the printing"
								linkPath2="#"
								linkName2="Lorem Ipsum is simply dummy text of the printing"
								linkPath3="#"
								linkName3="Lorem Ipsum is simply dummy text of the printing"
								linkPath4="#"
								linkName4="Lorem Ipsum is simply dummy text of the printing"
								linkPath5="#"
								linkName5="Lorem Ipsum is simply dummy text of the printing"
								linkPath6="#"
								linkName6="Lorem Ipsum is simply dummy text of the printing"
							></ModalRight>
						</div>
					)}

					{open && (
						<div>
							<Modal
								className="add-productgroup-modal"
								isOpen={open}
								cancelButton={() => setOpen(false)}
								onClose={() => setOpen(false)}
								title="Add New Group"
							>
								<AddProductGroup
									isOpen={open}
									onCLose={() => setOpen(false)}
									setPersistGroupName={setPersistGroupName}
									setAutoFocus={setAutoFocus}
									reloadTable={groupList}
									openGroupCode={() => {
										setIsOpenGroupCodeModel(true);
									}}
									callBackFunction={HandleGroupChange}
									shouldCallCalback={true}
								/>
							</Modal>
						</div>
					)}
					{isOpenGroupCodeModel && (
						<div>
							<Modal
								className="add-productgroup-modal"
								isOpen={isOpenGroupCodeModel}
								cancelButton={() => {
									setIsOpenGroupCodeModel(false);
								}}
								onClose={() => {
									setIsOpenGroupCodeModel(false);
								}}
								title="Add Group Code"
							>
								<CreateGroupCodeModel
									isOpen={isOpenGroupCodeModel}
									onCLose={() => {
										setIsOpenGroupCodeModel(false);
									}}
									reloadTable={() => {
										groupList();
									}}
									setGroupCode={setGroupCode}
									groupCode={groupCode}
									groupId={group}
								/>
							</Modal>
						</div>
					)}
					{isOpenCatogery && (
						<div>
							<Modal
								className="add-productgroup-modal"
								isOpen={isOpenCatogery}
								cancelButton={() => setIsOpenCatogery(false)}
								onClose={() => setIsOpenCatogery(false)}
								title="Add New Category"
							>
								<ProductCatogery
									isOpen={isOpenCatogery}
									onCLose={() => setIsOpenCatogery(false)}
									reloadTable={catogeryList}
									setAutoFocus={setAutoFocus}
									setPersistCatogery={setPersistCatogery}
									handleCatogery={handleCatogery}
								/>
							</Modal>
						</div>
					)}

					{isSheifId && (
						<div>
							<Modal
								className="add-productgroup-modal"
								isOpen={isSheifId}
								cancelButton={() => setIsShelfId(false)}
								onClose={() => setIsShelfId(false)}
								title="Add New shelf"
							>
								<Addshelf
									isOpen={isSheifId}
									onCLose={() => setIsShelfId(false)}
									reloadTable={shelfList}
									setAutoFocus={setAutoFocus}
									setPersistShelf={setPersistShelf}
									setShelf={setShelf}
								/>
							</Modal>
						</div>
					)}

					{isProductAutoSave && (
						<Modal
							className="deleteVendorsModal"
							title="Product Auto Save"
							isOpen={isProductAutoSave}
							onClose={() => {
								setIsProductAutoSave(false);
							}}
							cancelButton={() => {
								setIsProductAutoSave(false);
							}}
						>
							<div
								style={{
									textAlign: 'center',
									backgroundColor: '#E6F5FF',
									padding: '20px 10px',
									marginBottom: '20px',
									borderRadius: '5px',
									fontWeight: '600',
									color: 'black',
								}}
							>
								You have unsaved changes. Do you want to continue without saving?
							</div>

							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									gap: 10,
									justifyContent: 'end',
								}}
							>
								<Button
									type="button"
									button="Leave Without Saving"
									className="mt-0 px-4 btn-danger relative"
									onClick={() => {
										setIsLocationBlocker(false);
										setIsProductAutoSave(false);
										setTimeout(() => {
											navigate(isNextLocation.nextLocation?.pathname);
										}, 300);
									}}
								/>
								<Button
									type="button"
									button="Save and Continue"
									disabled={
										!hasPermission('inventory.products.create', user?.role?.role_permissions)
									}
									className="mt-0 px-4 btn-primary relative"
									onClick={() => {
										setIsProductAutoSave(false);
										SubmitForm();
									}}
								/>
							</div>
						</Modal>
					)}

					{buklImport && (
						<div>
							<Modal
								className="add-productgroup-modal"
								isOpen={buklImport}
								onClose={() => setIsbuklImport(false)}
								title=" Batch bulk Import "
							>
								<BulkImport
									isOpen={buklImport}
									onClose={() => setIsbuklImport(false)}
									type={'batch'}
									reloadTable={getProductById}
									productID={productID}
								/>
							</Modal>
						</div>
					)}
				</div>
			)}
		</>
	);
};

export default CreateProduct;
